import type { FencedCodeTextSegment } from '~/utils/leData/extractFencedCodeSegments';

export { restoreFencedCodeMarkdown } from '~/utils/leData/extractFencedCodeSegments';
export type {
  FencedCodeSegment,
  FencedCodeTextSegment,
  MarkdownSegment,
} from '~/utils/leData/extractFencedCodeSegments';

const FENCED_CODE_BLOCK_PATTERN = /(`{3,}|~{3,})([^\n]*)\n([\s\S]*?)\1(?:`|~)*/;

function normalizeFenceLanguage(info: string): string {
  return info.trim().split(/\s+/)[0]?.toLowerCase() ?? '';
}

function stripSingleTrailingNewline(content: string): string {
  return content.endsWith('\n') ? content.slice(0, -1) : content;
}

export function extractFencedCodeSegments(raw: string): Array<FencedCodeTextSegment> {
  const segments: Array<FencedCodeTextSegment> = [];
  let cursor = 0;
  let match: RegExpExecArray | null;

  const regex = new RegExp(FENCED_CODE_BLOCK_PATTERN.source, 'g');

  while ((match = regex.exec(raw)) !== null) {
    const before = raw.slice(cursor, match.index);
    if (before.trim()) {
      segments.push({ kind: 'markdown', content: before.trim() });
    }

    const info = match[2].trim();
    segments.push({
      kind: 'code',
      info,
      language: normalizeFenceLanguage(info),
      content: stripSingleTrailingNewline(match[3]),
    });

    cursor = match.index + match[0].length;
  }

  const trailing = raw.slice(cursor);
  const unfinishedFence = /(?:^|\n)(`{3,}|~{3,})([^\n]*)\n([\s\S]*)$/.exec(trailing);
  if (unfinishedFence) {
    const before = trailing.slice(0, unfinishedFence.index);
    if (before.trim()) {
      segments.push({ kind: 'markdown', content: before.trim() });
    }
    const info = unfinishedFence[2].trim();
    segments.push({
      kind: 'code',
      info,
      language: normalizeFenceLanguage(info),
      content: unfinishedFence[3],
    });
  } else if (trailing.trim()) {
    segments.push({ kind: 'markdown', content: trailing.trim() });
  }

  return segments.length > 0 ? segments : [{ kind: 'markdown', content: raw }];
}
